import axios from 'axios'
import {ParamsModel, StateParamsModel} from 'src/app/modules/common/Model'
import { HeadHuntApplicationModel } from '../Model'
const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const HEAD_HUNT = `${API_URL}/apply-headhunt`

export const service = {
  getHeadHuntApplications: (params: ParamsModel) => {
    return axios.get(HEAD_HUNT, {params})
  },

  updateHeadHuntApplications: (body: HeadHuntApplicationModel, id: string) => {
    return axios.put(`${HEAD_HUNT}/${id}`, body)
  },

  shortlistHeadHuntApplication: (id: string) => {
    return axios.put(`${HEAD_HUNT}/${id}/shortlist`)
  },

  rejectHeadHuntApplication: (id: string) => {
    return axios.put(`${HEAD_HUNT}/${id}/reject`)
  },

  deleteHeadHuntApplications: (data: HeadHuntApplicationModel) => {
    return axios.delete(HEAD_HUNT, {data})
  },

  getHeadHuntApplicantStatuses: () => {
    return axios.get(`${API_URL}/headhunt-applicant-status`)
  },

  // /apply-headhunt/export streams the CSV directly (no fileName round-trip,
  // matching how HeadHuntApplicantController::export() actually responds)
  exportHeadHuntApplications: (params: Partial<StateParamsModel>) => {
    return axios.get(`${HEAD_HUNT}/export`, {params, responseType: 'blob'})
  },

  // Full detail fetch for the view-details modal
  getHeadHuntApplication: (id: string) => {
    return axios.get(`${HEAD_HUNT}/application`, {params: {headHuntApplicantId: id}})
  },
}
